module.exports = __webpack_public_path__ + "img/hr-red-desert-bush-18.23685d08.png";